export function checkContextKey(row) {
    return JSON.stringify([row?._id, row?.updatedAt, row?.retailBrandID, row?.storeID, row?.supplierOrderType, row?.status]);
}
export function listingCheckKey(row) {
    return JSON.stringify(row?.automaticCheck || null);
}
export function reconcileCheckState(row, cached) {
    const fresh = row?.automaticCheck;
    if (!fresh?.enabled || !cached || cached.context !== checkContextKey(row) || cached.listing !== listingCheckKey(row)) return fresh;
    const result = cached.summary;
    if (!Number.isSafeInteger(result?.generation) || result.generation < (fresh.generation || 0) ||
        (result.businessRevision && Date.parse(result.businessRevision) !== Date.parse(row.updatedAt))) return fresh;
    return result;
}
export function isChecking(row, now = Date.now()) {
    return row?.automaticCheck?.enabled === true && row.automaticCheck.state === "checking" &&
        Date.parse(row.automaticCheck.leaseUntil) > now;
}
export function savedCount(row) {
    if(row?.status==="ExportedByRetailBrand")return "—";
    const c = row?.automaticCheck;
    return c?.enabled && ["complete", "partial"].includes(c.state) && Number.isSafeInteger(c.count) && c.count >= 0 ? c.count : "—";
}
export function canOpenSaved(row) {
    return row?.status !== "ExportedByRetailBrand" && row?.supplierOrderType === "Bulk Order" && row?.automaticCheck?.enabled === true &&
        row.automaticCheck.reportAvailable === true && !isChecking(row);
}
